var fn = function( obj ){
var __t,__p='';
__p+='#version 300 es\n\nin vec3 aPosition;\nin vec2 aTexCoord;\nin vec4 aTransform;\nin vec4 aVelocity;\nin vec4 aSettings;\n\n#define Speed aVelocity.w\n\n#define Position aTransform.xyz\n#define Rotation aTransform.w\n\n#define Scale aSettings.x * uGlobalScale\n#define AngularSpeed aSettings.y\n#define Lifetime aSettings.z\n#define Delay aSettings.w\n\nout vec2 vTexCoord;\n\nuniform mat4 uMVP;\nuniform float uTime;\nuniform float uGlobalScale;\n\nvec2 rotate(vec2 v, float a) {\n	float s = sin(a);\n	float c = cos(a);\n	mat2 m = mat2(c, s, -s, c);\n	return m * v;\n}\n\nvoid main(void){\n\n  float totalLifetime = mod(uTime - Delay, Lifetime + Delay);\n  float lifetime = max(totalLifetime - Delay, 0.0) / Lifetime;\n\n  vec3 position = aPosition;\n  position.xy = position.xy * Scale * smoothstep(0.0, 0.15, lifetime) * (1.0 - smoothstep(0.8, 1.0, lifetime));\n  position.xy = rotate(position.xy, Rotation * uTime * AngularSpeed * sign(-aVelocity.x));\n\n  position += Position;\n  position += aVelocity.xyz * lifetime * Speed;\n  \n  gl_Position = uMVP * vec4(position, 1.0);\n  vTexCoord = aTexCoord;\n}';
return __p;
};
fn.toString=fn;
export default fn;
fn._hmrListeners = []
fn.onHmr = function(l){
  this._hmrListeners.push( l )
}
fn._triggerHmr = function(){
  for (const l of this._hmrListeners) {
    l( this )
  }
}

if( import.meta.hot ){
  if( import.meta.hot.data && import.meta.hot.data._hmrListeners ){
    fn._hmrListeners = import.meta.hot.data._hmrListeners;
    fn._triggerHmr()
  }
  
  import.meta.hot.dispose(data => {
    data._hmrListeners = fn._hmrListeners;
  });
  
  import.meta.hot.accept(
    function(e){} // Function to handle errors when evaluating the new version
  );
}
